<template>
  <div class="">
    <div v-if="label" class="label">
      {{ label }}<span v-if="required" class="required-star">*</span>
    </div>
    <ValidationProvider
      :name="$attrs.label"
      :rules="rules"
      v-slot="{ errors }"
      :vid="vid"
    >
      <v-text-field
        class="custom-input"
        :type="type"
        v-model="innerValue"
        :error-messages="errors"
        v-bind="$attrs"
        v-on="$listeners"
        solo
        dense
        hide-details="auto"
        @change="emitChange"
        @keyup="handleNewCharacter"
        :value="innerValue"
        :disabled="disabled"
      ></v-text-field>
    </ValidationProvider>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import * as Validator from "vee-validate";

Validator.extend("RegexEmail", {
  message: "Błędny format adresu email. pl|com|eu|uk|net|de|ru|br|fr|it|in",
  validate: (value) => {
    var patt = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+(pl|eu|com|uk|net|de|ru|br|fr|it|in)))$/
    );
    return patt.test(value);
  },
});

Validator.extend("postalCode", {
  message: "Nieprawidłowy kod pocztowy",
  validate: (value) => {
    var patt = new RegExp(/^[0-9]{2}-[0-9]{3}$/);
    return patt.test(value);
  },
});

export default {
  components: {
    ValidationProvider,
  },
  props: {
    rules: {
      type: [Object, String],
      default: "",
    },
    value: {
      type: null,
    },
    vid: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      default: "text",
    },
    width: {
      type: Number,
      default: null,
    },
    onlyNumbers: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    innerValue: "",
  }),
  watch: {
    innerValue(newVal) {
      if (
        this.type === "number" &&
        this.innerValue &&
        this.innerValue.toString().match(/^[0-9]+,[0-9]+$/)
      ) {
        this.innerValue = this.innerValue.toString().replace(",", ".");
      }
      this.$emit("input", newVal);
    },
    value(newVal) {
      if (newVal) {
        this.innerValue = newVal.toString().trim();
      } else {
        this.innerValue = newVal;
      }
    },
  },
  methods: {
    handleNewCharacter(event) {
      if (this.onlyNumbers) {
        this.innerValue = this.innerValue.toString().replace(",", ".");
        const regex = /[^0-9.,]/g;
        this.innerValue = this.innerValue.replace(regex, "");
        if (event.key === "." && this.innerValue.includes(".")) {
          this.innerValue = this.innerValue.replace(/\.(?=.*\.)/g, "");
        }
      }
    },
    emitChange() {
      this.$emit("newValueAfterChange", this.innerValue);
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>

<style scoped>
.custom-input {
  margin: 20px 0;
  box-shadow: none !important;
  border: none !important;
}

.custom-input >>> .v-input {
  border-radius: 12px;
  background-color: white !important;
  box-shadow: none !important;
  border: none !important;
}

.custom-input >>> .v-input.v-input--solo,
.custom-input >>> .v-input.v-input--solo.v-input--is-focused {
  box-shadow: none !important;
  border: none !important;
}

.custom-input >>> .v-input__control {
  border-radius: 12px;
  padding: 0 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}

.custom-input >>> input {
  padding: 10px 15px !important;
  color: #6d6963;
  font-size: 12px;
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

.custom-input >>> .v-label {
  font-weight: 400;
  font-size: 12px;
  color: #6d6963 !important;
  opacity: 1 !important;
  transform: none !important;
  box-shadow: none !important;
  border: none !important;
}

/* Pola zablokowane / tylko do odczytu (np. dane z GUS) - lekko wyszarzone */
.custom-input.v-input--is-disabled >>> .v-input__slot,
.custom-input.v-input--is-readonly >>> .v-input__slot {
  background-color: #e9e7e4 !important;
  border-radius: 12px !important;
}
.custom-input >>> input:disabled,
.custom-input >>> input[readonly] {
  color: #8a857f !important;
}

.label {
  font-weight: 400;
  font-size: 12px;
  color: #6d6963;
}

.custom-input >>> .v-messages__message {
  color: #CE4257 !important;
}

.required-star {
  color: #ce4257;
  margin-left: 2px;
}
</style>
